<template>
  <form class="form-horizontal" @submit.prevent="updatePassword">
    <div class="row">
      <label class="col-sm-2 col-form-label">New Password</label>
      <div class="col-sm-8">
        <div class="form-group">
          <input type="password" placeholder="Must be atleast 6 charecters long" class="form-control" :class="{ 'is-valid': passWordLength.state, 'is-invalid': !passWordLength.state }" required v-model.trim="password">
          <div :class="{ 'valid-feedback': passWordLength.state, 'invalid-feedback': !passWordLength.state }">{{ passWordLength.message }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <label class="col-sm-2 col-form-label">Confirm Password</label>
      <div class="col-sm-8">
        <div class="form-group">
          <input type="password" placeholder="Must be atleast 6 charecters long" class="form-control" :class="{ 'is-valid': passwordMatch.state, 'is-invalid': !passwordMatch.state }" required v-model.trim="confirmPassword">
          <div :class="{ 'valid-feedback': passwordMatch.state, 'invalid-feedback': !passwordMatch.state }">{{ passwordMatch.message }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <label class="col-sm-2 col-form-label"></label>
      <div class="col-sm-10">
        <div class="form-group">
          <button class="btn btn-danger mt-0 text-white" :disabled="!passwordMatch.state">Update Password</button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { auth, db } from "@/firebase/init";

export default {
  name: "PasswordDetailsUpdate",
  data() {
    return {
      password: null,
      confirmPassword: null
    };
  },
  computed: {
    docID() {
      return this.$store.getters.getUID;
    },
    passWordLength() {
      if(this.password === null) {
        return {
          state: false,
          message: "Password must needs to be atleast 6 charecters long"
        }
      } else if(this.password.length > 5) {
        return {
          state: true,
          message: "Your password length is acceptable"
        }
      } else {
        return {
          state: false,
          message: "Password must needs to be atleast 6 charecters long"
        }
      }
    },
    passwordMatch() {
      if(this.password === null && this.confirmPassword === null) {
        return {
          state: false,
          message: "First please enter the new password then retype the same password in the confirm password section"
        }
      } else if( this.password === "" || this.confirmPassword === "") {
        return {
          state: false,
          message: "First please enter the new password then retype the same password in the confirm password section"
        }
      } else if(this.password !== this.confirmPassword) {
        return {
          state: false,
          message: "Password do not match"
        }
      } else {
        return {
          state: true,
          message: "Password matched"
        }
      }
    }
  },
  methods: {
    updatePassword() {
      // Check if the password is filled
      if ((this.password === this.confirmPassword) && this.password !== "" && this.password !== null && this.confirmPassword !== "" && this.confirmPassword !== null) {
        // Check if the password is atleast 6 charecters long else show error
        if (this.password.length > 5) {
          // Now we have a eligible password to be updated in the firebase auth
          // Set asyncDone to false
          this.$store.dispatch("async/stateUpdate", { state: false });

          // Call firebase auth to update the password
          auth.currentUser.updatePassword(this.confirmPassword)
            .then(async () => {

              // set last update password time...
              await db.collection('users').doc(auth.currentUser.uid).update({
                lastPasswordReset: new Date().toISOString()
              });

              // Set asyncDone to true
              this.$store.dispatch("async/stateUpdate", { state: true });

              this.password = null;

              // Show success alert for 8 seconds
              this.$store.dispatch("alert/update", {
                type: "success",
                message: 'Your password has successfully been updated',
                show: true
              });
              this.addLog({
                message:'Your password has successfully been updated',
                level: "info"
              })
              setTimeout(() => {
                this.$store.dispatch("alert/showUpdate", { show: false });
              }, 8000);
            })
            .catch(err => {
              // Set asyncDone to true
              this.$store.dispatch("async/stateUpdate", { state: true });

              this.password = null;

              // Show error alert for 5 sec
              this.$store.dispatch("alert/update", {
                type: "danger",
                message: err.message,
                show: true
              });

                this.addLog({
                    message: "Error: Error update user password. Message:" + err.message,
                    level:  "danger"
                });

              setTimeout(() => {
                this.$store.dispatch("alert/showUpdate", { show: false });
              }, 5000);
            });
        } else {
          this.password = null;

          // Show error alert for 5 sec
          this.$store.dispatch("alert/update", {
            type: "danger",
            message: "The password must needs to be 6 chaarecters long",
            show: true
          });
          this.addLog({
            message:'The password must needs to be 6 chaarecters long',
            level: "danger"
          })
          setTimeout(() => {
            this.$store.dispatch("alert/showUpdate", { show: false });
          }, 5000);
        }
      } else {
        this.password = null;

        // Show error alert for 5 sec
        this.$store.dispatch("alert/update", {
          type: "danger",
          message: "New Password and Confirm password details doesnt match.",
          show: true
        });
        this.addLog({
          message:'New Password and Confirm password details doesnt match.',
          level: "danger"
        })
        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", { show: false });
        }, 5000);
      }
    }
  }
};
</script>
